import React, { useEffect, useId } from 'react';
import config from 'src/config';
import loadHubSpotForms from 'src/services/hubspot/loadHubSpotForms';

type HubSpotFormsOptions = {
    region: string;
    portalId: string;
    formId: string;
    target: string;
};

declare global {
    interface Window {
        hbspt: {
            forms: {
                create: (options: HubSpotFormsOptions) => void;
            };
        };
    }
}

export type HubSpotFormProps = {
    /** The HubSpot form to embed. Every page has its own form, so there is no default. */
    formId: string;
    /** Overrides the shared NatureMetrics HubSpot account's region/portalId, for a form hosted elsewhere. */
    region?: string;
    portalId?: string;
};

const HubSpotForm = ({ formId, region, portalId }: HubSpotFormProps) => {
    const containerId = `hs-form-${useId().replace(/:/g, '')}`;

    useEffect(() => {
        let cancelled = false;

        loadHubSpotForms().then(() => {
            if (cancelled) return;

            window.hbspt.forms.create({
                region: region ?? config.hubSpotRegion,
                portalId: portalId ?? config.hubSpotPortalId,
                formId,
                target: `#${containerId}`,
            });
        });

        return () => {
            cancelled = true;
        };
    }, [containerId, region, portalId, formId]);

    return <div id={containerId} />;
};

export default HubSpotForm;
